import { ItineraryService } from './../itinerary.service';
import { ActivatedRoute } from "@angular/router";
import { Itinerary, CarTypeData, CarType } from "./../itineray.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Component, OnInit } from "@angular/core";
import { v4 as uuid } from "uuid";

@Component({
  selector: "app-itinerary-reservations-cars",
  templateUrl: "./itinerary-reservations-cars.component.html",
  styleUrls: ["./itinerary-reservations-cars.component.css"]
})
export class ItineraryReservationsCarsComponent implements OnInit {
  constructor(private route: ActivatedRoute, private snackBar: MatSnackBar, public itineraryService: ItineraryService) { }

  itinerary: Itinerary;

  expanded: boolean[];

  ngOnInit() {
    this.itinerary = this.route.parent.parent.snapshot.data.itinerary;
    this.syncExpanded();
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.itinerary.reservations.cars.forEach(() => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  removeCar($event, car) {
    $event.stopPropagation();
    if (confirm("Vuoi veramente eliminare questo mezzo?")) {
      const idx = this.itinerary.reservations.cars.indexOf(car);
      this.itinerary.reservations.cars.splice(idx, 1);
      this.snackBar
        .open("Mezzo eliminato.", "Annulla", {
          duration: 4000
        })
        .onAction()
        .subscribe(() => {
          this.itinerary.reservations.cars.splice(idx, 0, car);
          this.snackBar.open(
            "Il mezzo che avevi eliminato è stato inserito nuovamente nella lista.",
            null,
            {
              duration: 4000
            }
          );
        });
      this.syncExpanded();
    }
  }

  addCar() {
    this.itinerary.reservations.cars.push({
      id: uuid(),
      company: "",
      title: "",
      description: "",
      from: "",
      fromDetail: "",
      fromPlace: null,
      to: "",
      toDetail: "",
      toPlace: null,
      start: null,
      end: null,
      notes: null,
      link: { longUrl: null, shortUrl: null },
      partner: null,
      price: null,
      image: null,
      type: null
    });
    this.syncExpanded(true);
  }

  getCarTypeData(carType: CarType) {
    return CarTypeData.get(carType);
  }
}
